import { AppState } from '../store'

export const searchTextSelector = (state: AppState): string => {
  return (state && state.search) || ''
}
